import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {BazzarvoiceService} from '../../networking/services/bazzarvoice/bazzarvoice.service';

@Injectable({
  providedIn: 'root',
})
export class BazzarvoiceManager {
  constructor(private bzService: BazzarvoiceService) { }

  reviews(params?): Observable<any> {
    return this.bzService.reviews(params);
  }

  summary(params): Observable<any> {
    return this.bzService.summary(params);
  }

  setReviews(data): Observable<any> {
    return this.bzService.setReview(data);
  }
}
